import React, {useCallback, useMemo} from 'react';
import {useSessionUser} from '../../../../../data/hooks/sessionHooks';
import ConnectionSideUser from '../ConnectionSideUser/ConnectionSideUser';
import styles from './ConnectionSideSelf.module.scss';

function ConnectionSideSelf(props) {
    const {baseRoute} = props,
        user = useSessionUser(),
        targetPath = useMemo(() => [baseRoute, user.user_id ?? user.id ?? '-', user.participant_id ?? '-'].join('/'), [baseRoute, user]);

    const handleOpenUser = useCallback(() => {
        app.history.push(targetPath);
    }, [targetPath]);

    return (
        <>
            <ConnectionSideUser user={user} baseRoute={baseRoute} />
            <g className={styles.iconEdit} onClick={handleOpenUser}>
                <circle cx="159" cy="34" r="34" />
                <path d="m 168.67624,32.455225 0.70716,-0.706965 -2.12148,-2.12089 -3.88625,-3.885175 -2.12148,-2.120895 -0.70716,0.706965 -1.41432,1.41393 -12.46604,12.462585 c -0.65084,0.650655 -1.12645,1.457725 -1.38929,2.339865 l -2.21535,7.532605 c -0.15646,0.52553 -0.0125,1.094855 0.38174,1.48275 0.39426,0.38789 0.95748,0.531785 1.48316,0.381635 l 7.52843,-2.21474 c 0.88239,-0.262765 1.68968,-0.738245 2.34052,-1.3889 L 167.26192,33.87541 Z m -15.66391,10.53564 -0.56948,1.420185 c -0.25032,0.193945 -0.53194,0.33784 -0.83232,0.431685 l -4.8938,1.43895 1.43935,-4.88618 c 0.0876,-0.30656 0.23781,-0.588095 0.43181,-0.832095 l 1.42058,-0.569325 v 2.002025 c 0,0.550555 0.45058,1.00101 1.00128,1.00101 h 2.00258 z m 12.68507,-23.817805 -0.90116,0.907165 -1.41432,1.41393 -0.71341,0.706965 2.12148,2.12089 3.88625,3.885175 2.12148,2.12089 0.70716,-0.706965 1.41432,-1.413925 0.90741,-0.90717 c 1.56452,-1.564075 1.56452,-4.097885 0,-5.661965 l -2.45941,-2.46499 c -1.56451,-1.56408 -4.09902,-1.56408 -5.66354,0 z m -2.96631,10.510615 -9.0116,9.0091 c -0.388,0.38789 -1.02632,0.38789 -1.41432,0 -0.388,-0.387895 -0.388,-1.02604 0,-1.41393 l 9.0116,-9.0091 c 0.388,-0.38789 1.02632,-0.38789 1.41432,0 0.388,0.387895 0.388,1.02604 0,1.41393 z" />
            </g>
        </>
    );
}

export default ConnectionSideSelf;
